import React from 'react';
import './Avatar.css';

const COLORS = [
  '#e74c3c','#3498db','#2ecc71','#9b59b6',
  '#e67e22','#1abc9c','#e91e63','#f39c12',
  '#00bcd4','#8bc34a','#ff5722','#607d8b',
];

function hashStr(str) {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = str.charCodeAt(i) + ((h << 5) - h);
  return Math.abs(h);
}

function getInitials(displayName, username) {
  const name = (displayName || username || '?').trim();
  const parts = name.split(/\s+/);
  if (parts.length >= 2) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  return name.slice(0, 2).toUpperCase();
}

function Avatar({ user, size = 28 }) {
  if (!user) return null;
  const name     = user.displayName || user.username || '?';
  const initials = getInitials(user.displayName, user.username);
  const color    = COLORS[hashStr(name) % COLORS.length];
  const fontSize = Math.max(9, Math.round(size * 0.38));

  if (user.profileImage) {
    return (
      <img
        className="avatar-img"
        src={`${user.profileImage}?v=${user.updatedAt || ''}`}
        alt={name}
        style={{ width: size, height: size, borderRadius: '50%' }}
      />
    );
  }

  return (
    <span
      className="avatar-initials"
      title={name}
      style={{ width: size, height: size, background: color, fontSize }}
    >
      {initials}
    </span>
  );
}

export default Avatar;
